import { render, staticRenderFns } from "./TheKeySystemDrawer.vue?vue&type=template&id=4cb48d9b&"
import script from "./TheKeySystemDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheKeySystemDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports